var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"errBg",style:({ height: _vm.$store.state.clientHeight + 'px' })},[_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.$router.push({name:'home'})}}},[_vm._v("返回首页")])])}
var staticRenderFns = []

export { render, staticRenderFns }